import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import UsersScreen from '../screen'
import UserRoutes from '../../user/routes'

const UsersRoutes = () => {
    return (
        <React.Fragment>
            <Route path={CLIENT_ENDPOINTS.USERS} component={UsersScreen} />
            <UserRoutes />
        </React.Fragment>
    )
}

export default UsersRoutes